import { isFeatureEnabled } from 'owa-feature-flags';

export default function isFavoritesNoReflowEnabled() {
    return (
        isFeatureEnabled('acct-noreflow') &&
        isFeatureEnabled('tri-favorites-roaming') &&
        isFeatureEnabled('tri-favorites-noreflow')
    );
}
